import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {ServicesService} from "../../services/services-service.service";
import {take} from "rxjs";
import {ServicesFacadeService} from "../../angular/services/services-facade.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {RouteModel} from "../../../routes/models/route.model";
import {DeliveriesDialogService} from "../../services/deliveries-dialog-service.service";
import {FulfillmentService} from "../../../fulfillment/services/fulfillment-service.service";

export class DeliveriesActionBottomSheetCtrl implements IController {
  ids: any;
  routeIds?: string[];
  routes: RouteModel[];
  onActionComplete: any;
  selectedServices: any;
  onClear: Function;

  public servicesRef: any;
  public printerProvider: string;
  public services: any[];


  /* @ngInject */
  constructor(private servicesService: ServicesService, private DeliveriesApiAction, private $mdBottomSheet, private servicesFacadeService: ServicesFacadeService, private $delivery,
              private splitService: SplitService, private commonsDialogService: CommonsDialogService, private deliveriesDialogService: DeliveriesDialogService,
              private fulfillmentService: FulfillmentService) {
    this.servicesRef = this.$delivery();
    this.printerProvider = this.splitService.getPrinterProvider();
  }

  showListBottomSheet(event) {
    this.servicesFacadeService.selectByIds(this.ids).pipe(take(1)).subscribe((services) => {
      if (!!services.length) {
        this.services = services;
        let actions = this.servicesService.getActionsByServices(services, this.routes);
        if (this.printerProvider !== 'Ikea') {
          actions = this.removeIkeaFromExtraActions(actions);
        }
        this._toggleActionSheet(actions);
      } else {
        this.servicesRef.$asyncValues(this.ids).then((services) => {
          this.services = services;
          let actions = this.servicesService.getActionsByServices(services, this.routes);
          if (this.printerProvider !== 'Ikea') {
            actions = this.removeIkeaFromExtraActions(actions);
          }
          this._toggleActionSheet(actions);
        })
      }
    });
  }

  private _toggleActionSheet(actions) {
    const self = this;
    this.$mdBottomSheet.show({
      template: '<actions-bottom-sheet selected-services="selectedServices" actions="actions" ids="ids"></actions-bottom-sheet>',
      controller: function ($scope) {
        $scope.actions = actions;
        $scope.ids = self.ids;
        $scope.selectedServices = self.selectedServices;
      },
    }).then((clickedAction) => {
      // Handle all actions here.
      if (!clickedAction) {
        this.onClear();
      } else {
        if (clickedAction === 'PrintIkea') {
          this.commonsDialogService.printIkea(this.services);
        } else if (clickedAction === 'Duplicate') {
          this.servicesService.onDuplicateOne(this.services[0]);
        } else if (clickedAction === 'Print') {
          if (this.services[0].serviceType === 'Operation') {
            this.servicesService.onPrint([this.services[0].id]);
          } else {
            this.deliveriesDialogService.printDelivery()
              .then((purpose) => {
                this.servicesService.onPrint([this.services[0].id], purpose);
              })
          }
        } else if (clickedAction === 'dispatchExternal') {
          this.deliveriesDialogService.dispatchStepExternal(this.services[0].fulfillmentId, this.services[0].fulfillmentStepId, event)
            .then((selectedQuote) => {
              this.fulfillmentService.dispatchStep(this.services[0].fulfillmentId, this.services[0].fulfillmentStepId, selectedQuote);
            })
        } else {
          this.DeliveriesApiAction[clickedAction](event, this.ids)
            .then((deliveryIds) => {
              if (_.isArray(deliveryIds) && deliveryIds.length) {
                var hasStatusChanged = !_.isEqual(clickedAction, 'SendToMarket') && !_.isEqual(clickedAction, 'Auction') && !_.isEqual(clickedAction, 'CreateRoute');
                this.onActionComplete({hasStatusChanged: hasStatusChanged});
              }
            })
        }
      }
    }).catch((error) => {
    });
  }

  private removeIkeaFromExtraActions(actions) {
    return actions.filter(action => {
      return action.id !== "PrintIkea";
    })
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveriesActionBottomSheet', {
    bindings: {
      ids: '<',
      routeIds: '<?',
      routes: '<?',
      selectedServices: '<?',
      onActionComplete: '&',
      onClear: '&'
    },
    template: require('./deliveries-action-bottom-sheet.html').default,
    controller: DeliveriesActionBottomSheetCtrl
  });
